module.exports = __webpack_public_path__ + "static/media/Riser.2fbdd1e0.png";